export interface BackendApiResponse<T> {
  data: T;
  pagination?: ApiResponsePagination | ApiResponsePaginationNoTotal;
  errors?: ApiResponseMetaError[];
}

export interface ApiPagination {
  total: number;
  perPage: number;
  page: number;
  lastPage: number;
  from: number;
  to: number;
}

export interface ApiMeta {
  pagination?: ApiPagination;
}

export interface ApiResponse<T> extends BackendApiResponse<T> {
  meta?: ApiMeta;
}

export interface PaginableItemsList<T> {
  data: T;
  pagination: ApiResponsePagination | ApiResponsePaginationNoTotal;
}

export interface ApiResponsePagination {
  total: number;
  pages: number;
  currentPage: number;
  pageSize: number;
}

export interface ApiResponsePaginationNoTotal {
  total: undefined;
  currentPage: number;
  pageSize: number;
  hasNextPage: boolean;
}

export interface ApiResponseMetaError {
  propertyPath: string;
  message: string;
  [key: string]: any; // fixme specify type
}

export type AnyBackendApiResponse = BackendApiResponse<any>;

export const DEFAULT_REQUEST_PARAMS = {
  json: true,
  withCredentials: true,
};
